import {
  Autocomplete,
  Box,
  Button,
  Checkbox,
  Chip,
  FormControl,
  FormControlLabel,
  IconButton,
  InputAdornment,
  InputBase,
  OutlinedInput,
  Paper,
  Radio,
  RadioGroup,
  TextField,
  Typography,
} from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { useEffect, useState } from "react";
import people from "../../../../assets/svg/ellipse.svg";
import { useFormik } from "formik";
import * as Yup from "yup";
import dayjs from "dayjs";
import {
  addCampaignPromoCode,
  checkPromoCodeAvailability,
  generatePromoCode,
  getCampaigns,
  notifyCustomersOffer,
} from "../../../../helper/campaign";
import { useDispatch, useSelector } from "react-redux";
import {
  getAllCouriersFromEasyShip,
  getAllUsers,
  getBrands,
  getCustomersByRoutePartnerId,
} from "../../../../helper/functions";
import { toast } from "react-toastify";
import { setCampaigns } from "../../../../store/campaign";
import { addedByConversion } from "../../../Shipping/ShippingService/shippingService.helper";

const initalValues = {
  forAllCustomers: false,
  forAllUsers: false,
  emails: [],
  totalDiscount: 0,
  maxDisAmount: 0,
  isNoMaxAmount: false,
  promoCode: "",
  usedFor: "",
  expiryDate: "",
  isNeverExpire: false,
  publicNote: "",
  internalNote: "",
  isAppliedToAllCouriers: false,
  isAppliedToAllBrands: false,
  appliedCouriers: [],
  appliedBrands: [],
};

// Validation schema
const validationSchema = Yup.object().shape({
  totalDiscount: Yup.number()
    .required("Total discount is required")
    .min(1, "Total discount must be at least 1%")
    .max(100, "Total discount cannot exceed 100%"),
  maxDisAmount: Yup.number().when("isNoMaxAmount", {
    is: false,
    then: (schema) =>
      schema
        .required(
          "Maximum amount is required when 'No maximum amount' is unchecked",
        )
        .min(0.01, "Maximum amount must be greater than 0"),
  }),
  promoCode: Yup.string()
    .required("Promo code is required")
    .min(3, "Promo code must be at least 3 characters"),
  usedFor: Yup.string().required("Please select how funds can be used"),
  expiryDate: Yup.string().when("isNeverExpire", {
    is: false,
    then: (schema) =>
      schema.required(
        "Expiry date is required when 'Never Expired' is unchecked",
      ),
  }),
  appliedBrands: Yup.array().when(["usedFor", "isAppliedToAllBrands"], {
    is: (usedFor, isAppliedToAllBrands) =>
      (usedFor === "shopping" || usedFor === "global") && !isAppliedToAllBrands,
    then: (schema) =>
      schema
        .min(1, "Please select at least one brand/retailer")
        .required("Brands/Retailers selection is required"),
  }),
  appliedCouriers: Yup.array().when(["usedFor", "isAppliedToAllCouriers"], {
    is: (usedFor, isAppliedToAllCouriers) =>
      (usedFor === "shipping" || usedFor === "global") &&
      !isAppliedToAllCouriers,
    then: (schema) =>
      schema
        .min(1, "Please select at least one courier")
        .required("Couriers selection is required"),
  }),
});

const AddPromoCode = ({ setAddFundDrawer }) => {
  const dispatch = useDispatch();
  const [customerMails, setCustomerMails] = useState([]);
  const [brands, setBrands] = useState([]);
  const [couriers, setCouriers] = useState([]);
  const user = useSelector((state) => state.auth.value);
  console.log(user, "userdfsdf");

  useEffect(() => {
    const getCustomers = async () => {
      const customers = await getCustomersByRoutePartnerId(
        user?.routePartnerId,
      );
      setCustomerMails(customers);
      console.log(customers, "customers1111");
    };
    const getUsers = async () => {
      const users = await getAllUsers();
      console.log(users, "usersacds");
      setCustomerMails(users);
    };
    const getAllBrands = async () => {
      const brands = await getBrands();
      console.log(brands, "brandscsds");
      setBrands(
        brands?.map((brand) => ({
          link: brand?.brandLink,
          name: brand?.brandName,
        })),
      );
    };
    const getAllCouriers = async () => {
      const courier = await getAllCouriersFromEasyShip();
      console.log(courier, "couriers1111");
      setCouriers(courier);
    };
    if (user) {
      if (user?.role === "Route Partner Admin") {
        getCustomers();
      } else {
        getUsers();
      }
      getAllBrands();
      getAllCouriers();
    }
  }, [user]);

  const formik = useFormik({
    initialValues: initalValues,
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      const isAllUsers = values.forAllCustomers || values.forAllUsers;
      const campaignEmails = isAllUsers
        ? []
        : values.emails.map((e) => ({ email: e.email, userId: e.userId }));
      const userIds = isAllUsers ? [] : values.emails.map((e) => e.userId);
      const brandLinks = values.appliedBrands.map((b) => b.link);
      const courierIds = values.appliedCouriers.map((c) => c.id);

      const result = await checkPromoCodeAvailability(values.promoCode);
      if (!result) {
        return toast.error("Promo code already exists");
      }
      const offeredBy =
        user?.role === "Superadmin" ? "POSTPAL" : user?.routePartnerName;

      const payload = {
        ...values,
        emails: campaignEmails,
        forAllUsers: isAllUsers,
        campaignType: "promo_code",
        addedByUserId: user?.id || "",
        routePartnerId: user?.routePartnerId || "",
        addedBy: addedByConversion(user?.role),
        offeredBy,
        status: "active",
        userIds,
        brandLinks,
        courierIds,
      };

      console.log(payload, "valuesadfdfd");
      addCampaignPromoCode(payload).then(async (res) => {
        const response = await getCampaigns();
        dispatch(setCampaigns(response));
        setAddFundDrawer(false);
        toast.success("Promo code added successfully");
      });
    },
  });

  const emailOptions = customerMails.map((option) => ({
    email: option.email,
    userId: option.id,
  }));

  const courierOptions = couriers.map((courier) => ({
    id: courier.id,
    display: `${courier.umbrella_name}-${courier.origin_country_alpha2}`,
  }));

  return (
    <Box>
      {user?.role === "Route Partner Admin" && (
        <Box
          sx={{
            paddingX: "20px",
          }}
        >
          <FormControlLabel
            label="For all customers"
            control={
              <Checkbox
                size="small"
                onChange={(event) => {
                  if (event.target.checked) {
                    formik.setFieldValue("emails", []);
                  }
                  formik.setFieldValue("forAllCustomers", event.target.checked);
                }}
              />
            }
          />
        </Box>
      )}
      {user?.role != "Route Partner Admin" && (
        <Box
          sx={{
            paddingX: "20px",
          }}
        >
          <FormControlLabel
            label="For all users"
            control={
              <Checkbox
                size="small"
                onChange={(event) => {
                  if (event.target.checked) {
                    formik.setFieldValue("emails", []);
                  }
                  formik.setFieldValue("forAllUsers", event.target.checked);
                }}
              />
            }
          />
        </Box>
      )}
      <Box sx={{ paddingX: "20px", paddingTop: "10px" }}>
        <Typography sx={{ fontSize: "14px", fontWeight: 500 }}>
          Email
        </Typography>
        <FormControl fullWidth>
          <Autocomplete
            multiple
            size="small"
            options={emailOptions}
            getOptionLabel={(option) => option.email}
            value={formik.values.emails}
            disabled={
              formik.values.forAllCustomers || formik.values.forAllUsers
            }
            onChange={(event, newValue) => {
              formik.setFieldValue("emails", newValue);
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                variant="outlined"
                placeholder="Select emails"
              />
            )}
            renderTags={(value, getTagProps) =>
              value.map((option, index) => (
                <Chip
                  variant="outlined"
                  label={option.email}
                  {...getTagProps({ index })}
                />
              ))
            }
          />
        </FormControl>
      </Box>
      <Box
        sx={{
          paddingX: "20px",
          paddingTop: "20px",
        }}
      >
        <Typography sx={{ fontSize: "14px", fontWeight: 500 }}>
          Total discount <span style={{ color: "red" }}>*</span>
        </Typography>
        <FormControl fullWidth>
          <OutlinedInput
            id="outlined-adornment-amount"
            type="number"
            value={formik?.values?.totalDiscount}
            onChange={(event) =>
              formik.setFieldValue("totalDiscount", +event.target.value)
            }
            onBlur={formik.handleBlur}
            startAdornment={<InputAdornment position="start">%</InputAdornment>}
            error={
              formik.touched.totalDiscount &&
              Boolean(formik.errors.totalDiscount)
            }
          />
          {formik.touched.totalDiscount && formik.errors.totalDiscount && (
            <Typography
              variant="caption"
              color="error"
              sx={{ mt: 0.5, display: "block" }}
            >
              {formik.errors.totalDiscount}
            </Typography>
          )}
        </FormControl>
      </Box>
      <Box
        sx={{
          paddingX: "20px",
          paddingTop: "10px",
        }}
      >
        <Typography sx={{ fontSize: "14px", fontWeight: 500 }}>
          Max. amount{" "}
          {!formik?.values?.isNoMaxAmount && (
            <span style={{ color: "red" }}>*</span>
          )}
        </Typography>
        <FormControl fullWidth>
          <OutlinedInput
            id="outlined-adornment-amount"
            type="number"
            value={formik?.values?.maxDisAmount}
            disabled={formik?.values?.isNoMaxAmount}
            onChange={(event) =>
              formik.setFieldValue("maxDisAmount", +event.target.value)
            }
            onBlur={formik.handleBlur}
            startAdornment={<InputAdornment position="start">$</InputAdornment>}
            size="small"
            error={
              formik.touched.maxDisAmount && Boolean(formik.errors.maxDisAmount)
            }
          />
          {formik.touched.maxDisAmount && formik.errors.maxDisAmount && (
            <Typography
              variant="caption"
              color="error"
              sx={{ mt: 0.5, display: "block" }}
            >
              {formik.errors.maxDisAmount}
            </Typography>
          )}
        </FormControl>
      </Box>
      <Box
        sx={{
          paddingX: "20px",
        }}
      >
        <FormControlLabel
          label="No maximum amount"
          control={
            <Checkbox
              size="small"
              onChange={(event) => {
                if (event.target.checked) {
                  formik.setFieldValue("maxDisAmount", 0);
                }
                formik.setFieldValue("isNoMaxAmount", event.target.checked);
              }}
            />
          }
        />
      </Box>
      <Box sx={{ paddingX: "20px", paddingTop: "10px" }}>
        <label style={{ fontSize: "14px", fontWeight: 500 }}>
          Promo Code <span style={{ color: "red" }}>*</span>
        </label>
        <Paper
          component="form"
          sx={{
            p: "2px 4px",
            display: "flex",
            alignItems: "center",
            border:
              formik.touched.promoCode && formik.errors.promoCode
                ? "1px solid #d32f2f"
                : "1px solid #E5E5E8",
            height: 40,
            marginTop: "10px",
          }}
        >
          <InputBase
            sx={{ ml: 1, flex: 1 }}
            placeholder="Search... "
            inputProps={{ "aria-label": "search" }}
            size="small"
            name="promoCode"
            value={formik?.values?.promoCode}
            onChange={(event) =>
              formik.setFieldValue("promoCode", event.target.value)
            }
            onBlur={formik.handleBlur}
          />
          <IconButton
            color="primary"
            sx={{ p: "10px" }}
            aria-label="directions"
            disabled={formik?.values?.promoCode}
            onClick={async () => {
              formik.setFieldValue("promoCode", await generatePromoCode(7));
            }}
          >
            <Typography variant="body1" fontWeight="bold">
              Generate
            </Typography>
          </IconButton>
        </Paper>
        {formik.touched.promoCode && formik.errors.promoCode && (
          <Typography
            variant="caption"
            color="error"
            sx={{ mt: 0.5, display: "block" }}
          >
            {formik.errors.promoCode}
          </Typography>
        )}
      </Box>
      <Box sx={{ paddingX: "20px", paddingTop: "20px" }}>
        <Typography sx={{ fontSize: "14px", fontWeight: 500 }}>
          Funds can be used for <span style={{ color: "red" }}>*</span>
        </Typography>
        <FormControl>
          <RadioGroup
            row
            aria-labelledby="demo-row-radio-buttons-group-label"
            name="row-radio-buttons-group"
            onChange={(event) => {
              if (event.target.value === "shipping") {
                formik.setFieldValue("isAppliedToAllCouriers", true);
                formik.setFieldValue("isAppliedToAllBrands", false);
              }
              if (event.target.value === "shopping") {
                formik.setFieldValue("isAppliedToAllBrands", true);
                formik.setFieldValue("isAppliedToAllCouriers", false);
              } else {
                formik.setFieldValue("isAppliedToAllBrands", true);
                formik.setFieldValue("isAppliedToAllCouriers", true);
              }
              formik.setFieldValue("usedFor", event.target.value);
            }}
            value={formik.values.usedFor}
          >
            <FormControlLabel
              value="shopping"
              control={<Radio />}
              label="Shopping"
            />
            <FormControlLabel
              value="shipping"
              control={<Radio />}
              label="Shipping"
            />
            <FormControlLabel
              value="global"
              control={<Radio />}
              label="Global"
            />
          </RadioGroup>
        </FormControl>
        {formik.touched.usedFor && formik.errors.usedFor && (
          <Typography
            variant="caption"
            color="error"
            sx={{ mt: 0.5, display: "block" }}
          >
            {formik.errors.usedFor}
          </Typography>
        )}
      </Box>
      {["shopping", "global"].includes(formik?.values?.usedFor) && (
        <Box
          sx={{
            paddingX: "20px",
          }}
        >
          <FormControlLabel
            label="Applies to All Brands/Retailers"
            control={
              <Checkbox
                size="small"
                checked={formik?.values?.isAppliedToAllBrands}
                onChange={(event) => {
                  formik.setFieldValue(
                    "isAppliedToAllBrands",
                    event.target.checked,
                  );
                  if (event.target.checked) {
                    formik.setFieldValue("appliedBrands", []);
                  }
                }}
              />
            }
          />
        </Box>
      )}
      {["shopping", "global"].includes(formik?.values?.usedFor) &&
        !formik?.values?.isAppliedToAllBrands && (
          <Box sx={{ paddingX: "20px", paddingTop: "10px" }}>
            <Typography sx={{ fontSize: "14px", fontWeight: 500 }}>
              Applies to Brands/Retailers{" "}
              <span style={{ color: "red" }}>*</span>
            </Typography>
            <FormControl fullWidth>
              <Autocomplete
                multiple
                size="small"
                options={brands}
                getOptionLabel={(option) => option.name}
                value={formik?.values?.appliedBrands || []}
                onChange={(event, newValue) => {
                  console.log(newValue, "newValueasdds");
                  formik.setFieldValue("appliedBrands", newValue);
                }}
                onBlur={formik.handleBlur}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    placeholder="Select Brands"
                    error={
                      formik.touched.appliedBrands &&
                      Boolean(formik.errors.appliedBrands)
                    }
                  />
                )}
                renderTags={(value, getTagProps) =>
                  value.map((option, index) => (
                    <Chip
                      variant="outlined"
                      label={option.name}
                      {...getTagProps({ index })}
                    />
                  ))
                }
              />
              {formik.touched.appliedBrands && formik.errors.appliedBrands && (
                <Typography
                  variant="caption"
                  color="error"
                  sx={{ mt: 0.5, display: "block" }}
                >
                  {formik.errors.appliedBrands}
                </Typography>
              )}
            </FormControl>
          </Box>
        )}
      {["shipping", "global"].includes(formik?.values?.usedFor) && (
        <Box
          sx={{
            paddingX: "20px",
          }}
        >
          <FormControlLabel
            label="Applies to All Couriers"
            control={
              <Checkbox
                size="small"
                checked={formik?.values?.isAppliedToAllCouriers}
                onChange={(event) => {
                  formik.setFieldValue(
                    "isAppliedToAllCouriers",
                    event.target.checked,
                  );
                  if (event.target.checked) {
                    formik.setFieldValue("appliedCouriers", []);
                  }
                }}
              />
            }
          />
        </Box>
      )}
      {["shipping", "global"].includes(formik?.values?.usedFor) &&
        !formik?.values?.isAppliedToAllCouriers && (
          <Box sx={{ paddingX: "20px", paddingTop: "10px" }}>
            <Typography sx={{ fontSize: "14px", fontWeight: 500 }}>
              Applies to Couriers <span style={{ color: "red" }}>*</span>
            </Typography>
            <FormControl fullWidth>
              <Autocomplete
                multiple
                size="small"
                options={courierOptions}
                getOptionLabel={(option) => option.display}
                value={formik?.values?.appliedCouriers || []}
                onChange={(event, newValue) => {
                  formik.setFieldValue("appliedCouriers", newValue);
                }}
                onBlur={formik.handleBlur}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    placeholder="Select Couriers"
                    error={
                      formik.touched.appliedCouriers &&
                      Boolean(formik.errors.appliedCouriers)
                    }
                  />
                )}
                renderTags={(value, getTagProps) =>
                  value.map((option, index) => (
                    <Chip
                      variant="outlined"
                      label={option.display}
                      {...getTagProps({ index })}
                    />
                  ))
                }
              />
              {formik.touched.appliedCouriers &&
                formik.errors.appliedCouriers && (
                  <Typography
                    variant="caption"
                    color="error"
                    sx={{ mt: 0.5, display: "block" }}
                  >
                    {formik.errors.appliedCouriers}
                  </Typography>
                )}
            </FormControl>
          </Box>
        )}
      <Box sx={{ paddingX: "20px", paddingTop: "10px" }}>
        <Typography sx={{ fontSize: "14px", fontWeight: 500 }}>
          Expiry Date{" "}
          {!formik?.values?.isNeverExpire && (
            <span style={{ color: "red" }}>*</span>
          )}
        </Typography>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DatePicker
            onChange={(newValue) =>
              formik.setFieldValue(
                "expiryDate",
                dayjs(newValue).format("YYYY-MM-DD"),
              )
            }
            value={dayjs(formik?.values?.expiryDate)}
            disabled={formik?.values?.isNeverExpire}
            renderInput={(params) => (
              <TextField
                {...params}
                name="endDate"
                error={
                  formik.touched.expiryDate && Boolean(formik.errors.expiryDate)
                }
              />
            )}
            sx={{
              width: "100%",
            }}
          />
        </LocalizationProvider>
        {formik.touched.expiryDate && formik.errors.expiryDate && (
          <Typography
            variant="caption"
            color="error"
            sx={{ mt: 0.5, display: "block" }}
          >
            {formik.errors.expiryDate}
          </Typography>
        )}
      </Box>
      <Box
        sx={{
          paddingX: "20px",
        }}
      >
        <FormControlLabel
          label="Never Expired"
          control={
            <Checkbox
              size="small"
              onChange={(event) => {
                if (event.target.checked) {
                  formik.setFieldValue("expiryDate", "");
                }
                formik.setFieldValue("isNeverExpire", event.target.checked);
              }}
            />
          }
        />
      </Box>
      <Box sx={{ marginX: "20px", paddingTop: "10px" }}>
        <Typography sx={{ fontSize: "14px", fontWeight: 500 }}>
          Public Note
        </Typography>
        <TextField
          name="publicNote"
          variant="outlined"
          size="small"
          fullWidth
          onChange={(event) =>
            formik.setFieldValue("publicNote", event.target.value)
          }
          value={formik?.values?.publicNote}
        />
      </Box>
      <Box sx={{ marginX: "20px", paddingTop: "20px" }}>
        <Typography sx={{ fontSize: "14px", fontWeight: 500 }}>
          Internal Note
        </Typography>
        <TextField
          variant="outlined"
          size="small"
          fullWidth
          multiline
          rows={5}
          name="internalNote"
          value={formik?.values?.internalNote}
          onChange={(event) =>
            formik.setFieldValue("internalNote", event.target.value)
          }
        />
      </Box>
      <Box sx={{ marginX: "20px", paddingTop: "10px", paddingBottom: "20px" }}>
        <Typography sx={{ fontSize: "14px", fontWeight: 500 }}>
          Applied by
        </Typography>
        <Box sx={{ display: "flex", alignItems: "center", marginTop: "10px" }}>
          <img src={people} alt="people" width={24} height={24} />
          <Typography sx={{ marginLeft: "10px" }}>{user?.name}</Typography>
        </Box>
      </Box>
      {/* Fixed positioned button at bottom right */}
      <Box
        sx={{
          position: "fixed",
          bottom: "20px",
          right: "20px",
          zIndex: 1000,
        }}
      >
        <Button
          variant="contained"
          sx={{
            backgroundColor: "#481AA3",
            color: "#fff",
            border: "none",
            boxShadow: "0px 4px 12px rgba(72, 26, 163, 0.3)",
            padding: "12px 24px",
            borderRadius: "8px",
            fontSize: "14px",
            fontWeight: 600,
            textTransform: "none",
            minWidth: "180px",
            height: "48px",
            transition: "all 0.3s ease",
            "&:hover": {
              backgroundColor: "#5E17EB",
              boxShadow: "0px 6px 16px rgba(72, 26, 163, 0.4)",
              transform: "translateY(-2px)",
            },
            "&:active": {
              transform: "translateY(0px)",
            },
          }}
          onClick={formik.handleSubmit}
          disabled={!formik.isValid || formik.isSubmitting}
        >
          Generate Promo Code
        </Button>
      </Box>
    </Box>
  );
};

export default AddPromoCode;
